import { NgModule } from '@angular/core';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {RouterModule} from '@angular/router';
import {procedurePublisherRoutes} from '@features/publisher/publisher.routes';
import {PublisherGridHandler} from '@features/publisher/services/publisher-grid.handler';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {Api} from "@shared/constants/common-field.constants";
import {PlatformToolAutomatePublicationHandler} from "@features/publisher/services/platform-tool-automate-publication-handler.service";


@NgModule({
  declarations: [
  ],
  imports: [
    RouterModule.forChild(procedurePublisherRoutes)
  ],
  exports: []
})
export class PublisherModule {
  constructor(private  publisherGridHandler: PublisherGridHandler,
              private platformToolAutomatePublicationHandler: PlatformToolAutomatePublicationHandler,
              private commandService: CommandService) {
    RootDynamicComponentHelper.register('PublisherGridHandler', publisherGridHandler);
    RootDynamicComponentHelper.register('PlatformToolAutomatePublicationHandler', platformToolAutomatePublicationHandler);
    const taxFormPublisherCommand = new PlatformCommand('TaxFormPublisherViewDialogCommand', Api.TaxForm);
    this.commandService.registrPlatformLinkCommand('/tax-form-publisher', taxFormPublisherCommand);
    const procedurePublisherCommand = new PlatformCommand('ProcedurePublisherViewDialogCommand', Api.WhtForm);
    this.commandService.registrPlatformLinkCommand('/procedure-publisher', procedurePublisherCommand);
    const publicationCommand = new PlatformCommand('CreatePublicationLinkCommand', Api.XatBotApi);
    publicationCommand.fieldValues['PublicationType'] = 'DueDateTracker';
    this.commandService.registrPlatformLinkCommand('/publications/duedatetracker', publicationCommand);
    //
    const crPublisherCommand = new PlatformCommand('CreatePublicationLinkCommand', Api.XatBotApi);
    crPublisherCommand.fieldValues['PublicationType'] = 'ChangeReportTracker';
    this.commandService.registrPlatformLinkCommand('/publications/change-report-tracker', crPublisherCommand);
    //
    const crPublisherDataLinkCommand = new PlatformCommand('CrPublicationDataLinkCommand', Api.XatBotApi);
    crPublisherDataLinkCommand.fieldValues['PublicationType'] = 'ChangeReportTracker';
    this.commandService.registrPlatformLinkCommand('/publications/change-report-tracker/:publicationId', crPublisherDataLinkCommand);

    const publisherDataLinkCommand = new PlatformCommand('PublicationDataLinkCommand', Api.XatBotApi);
    publisherDataLinkCommand.fieldValues['PublicationType'] = 'DueDateTracker';
    this.commandService.registrPlatformLinkCommand('/publications/duedatetracker/:publicationId', publisherDataLinkCommand);
  }
}
